import React from 'react';

export default function Footer() {
  return (
    <footer className="app-footer">
      <p>© Trinity Dental / Odyssey Solutions — HIPAA Compliance Training Portal</p>
    </footer>
  );
}
